import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';
import { Subscription } from '@price-card/models/subscription.model';

export interface PriceCardSubscriptionsState {
  subscriptions: Subscription[];
  isFetching: boolean;
  error?: string;
}

const initialState: PriceCardSubscriptionsState = {
  subscriptions: [],
  isFetching: false,
};

export const priceCardSubscriptionsSlice = createSlice({
  name: 'price-card-subscriptions',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    subscribeToPriceCard: (state, _action: PayloadAction<Subscription>) => {
      state.isFetching = true;
    },
    subscribeToPriceCardSuccess: (state, action: PayloadAction<Subscription>) => {
      state.isFetching = false;
      state.subscriptions = [...state.subscriptions, action.payload];
    },
    subscribeToPriceCardFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
    retrievePriceCardSubscriptions: (state) => {
      state.isFetching = true;
    },
    retrievePriceCardSubscriptionsSuccess: (state, action: PayloadAction<Subscription[]>) => {
      state.subscriptions = action.payload;
      state.isFetching = false;
    },
    retrievePriceCardSubscriptionsFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    unsubscribeToPriceCard: (state, _action: PayloadAction<number>) => {
      state.isFetching = true;
    },
    unsubscribeToPriceCardSuccess: (state, action: PayloadAction<number>) => {
      state.isFetching = false;
      state.subscriptions = state.subscriptions.filter(subscription => subscription.id !== action.payload);
    },
    unsubscribeToPriceCardFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export type PriceCardSubscriptionsViewModel = {
  subscriptions: Subscription[];
  isFetching: boolean;
  error?: string;
};

export const selectPriceCardSubscriptionsViewModel = createSelector(
  (state: RootState) => state,
  (state): PriceCardSubscriptionsViewModel => ({
    subscriptions: state.priceCard.subscription.subscriptions,
    isFetching: state.priceCard.subscription.isFetching,
    error: state.priceCard.subscription.error,
  }),
);
export const {
  subscribeToPriceCard,
  subscribeToPriceCardSuccess,
  subscribeToPriceCardFailure,
  retrievePriceCardSubscriptions,
  retrievePriceCardSubscriptionsSuccess,
  retrievePriceCardSubscriptionsFailure,
  unsubscribeToPriceCard,
  unsubscribeToPriceCardSuccess,
  unsubscribeToPriceCardFailure,
} =
  priceCardSubscriptionsSlice.actions;

export default priceCardSubscriptionsSlice.reducer;
